import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { OptionService } from '@root/router/index/option.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { filter } from 'rxjs';
import { EditHouseComponent } from '@root/router/component/property/edit-house/edit-house.component';
import { TranslateService } from '@root/shared/service/translate.service';
import { ModalService } from '@root/router/index/modal.service';

@Component({
  selector: 'host-room-type-detail',
  templateUrl: './room-type-detail.component.html',
  styleUrls: ['./room-type-detail.component.scss'],
})
export class RoomTypeDetailComponent implements OnInit, OnDestroy {
  readonly detailApi = '/api/house_type/details';
  private readonly saveTagsApi = '/api/house_type/save_tags';
  @Input() id;
  @Input() tab = 0;
  @Input() appendPageData: any = null;
  detail;
  tagEditing = false;
  tagIds;
  // get optionsOfHouseTag() {
  //   return this.optSrv.optionsOfHouseTag;
  // }
  optionsOfHouseTag = [];

  calendarDrawerRef;
  constructor(
    private http: HttpClient,
    private drawerRef: NzDrawerRef,
    private optSrv: OptionService,
    private modal: NzModalService,
    private globalModal: ModalService,
    private msg: NzMessageService,
    private router: Router,
    private renderer: Renderer2,
    private ele: ElementRef,
    private t: TranslateService
  ) {}

  ngOnInit() {
    this.initTagOption();
    this.initTypeDetail();

    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.drawerRef.close());
  }

  ngOnDestroy(): void {
    this.calendarDrawerRef?.close();
  }

  handleGlobalClick(event) {
    if (this.tagEditing) {
      this.requestSaveTags();
    }
  }

  initTagOption() {
    this.http.get('/api/house_status_setting/get').subscribe((rst: any) => {
      this.optionsOfHouseTag = rst?.data?.house_tag
        .filter((t) => !t.delete_time)
        .map((t) => ({
          label: t.name,
          value: t.id,
          color: t.color,
        }));
    });
  }

  private initTypeDetail() {
    const params = { house_type_id: this.id };
    this.http.get(this.detailApi, { params }).subscribe((rst: any) => {
      this.detail = rst?.data;
      this.tagIds = this.detail?.tags?.map((t) => t.id);
      console.log('this.houseDetail: ', this.detail);
    });
  }

  onTagOpenChange(open) {
    // console.log("open: ", open);
    // if (!open) {
    //   this.requestSaveTags();
    // }
  }

  autoFocusSelect() {
    setTimeout(() => {
      const se = this.ele.nativeElement.querySelector('._antd-select');
      if (!this.tagIds?.length) {
        se.click();
      }
    }, 300);
  }

  onSubpageNavigate() {
    this.ele.nativeElement.querySelector('.ant-tabs-content-holder').scrollTop = 0;
  }

  onSubpageUpdate() {
    this.initTypeDetail();
  }

  onEditHouse() {
    const modal = this.modal.create({
      nzTitle: this.t.t('word.edit'),
      nzContent: EditHouseComponent,
      nzWidth: 500,
      nzFooter: null,
      nzComponentParams: {
        type: 'type',
        data: {
          id: this.id,
          cover: this.detail?.cover?.small_url,
          title: this.detail?.title,
        },
      },
    });
    modal.afterClose.subscribe((rst) => {
      if (rst?.status === 'ok') {
        this.initTypeDetail();
      }
    });
  }

  onDisplayCalendar() {
    this.calendarDrawerRef = this.globalModal.displayRoomTypeCalendarDrawer(this.id);
  }

  onRemoveType() {
    this.displayRemoveTypeWarning().subscribe(() => {
      this.http.post('/api/house_type/delete', { house_type_id: this.id }).subscribe((rst: any) => {
        if (rst.error_code === 0) {
          this.msg.success(this.t.t('word.removed'));
          // this.initTypeDetail();
          this.drawerRef?.close();
        }
      });
    });
  }

  toSettingOptionPage() {
    this.router.navigate(['/app/settings/custom-options'], { queryParams: { anchor: 'tags' } });
    // this.drawerRef.close();
  }

  private displayRemoveTypeWarning() {
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        nzTitle: this.t.t('property-room_type_detail_ts_删除标题'),
        nzContent: this.t.t('property-room_type_detail_ts_删除内容'),
        nzOkText: this.t.t('word.yes'),
        nzWidth: 500,
        nzOnOk: () => observer.next(null),
      });

      modal.afterClose.subscribe(() => observer.complete());
    });
  }

  private requestSaveTags() {
    const params = {
      house_type_id: this.id,
      house_tag_ids: this.tagIds,
    };
    this.http.post(this.saveTagsApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.initTypeDetail();
        this.tagEditing = false;
      }
    });
  }

  onClose() {
    this.drawerRef.close();
  }
}
